import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import axios from 'axios';
import { Avatar, Backdrop, CircularProgress, FormControl, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';

const mdTheme = createTheme();

function OtherAds() {
  const [page, setPage] = React.useState(0);
  const [rows, setRows] = React.useState([]);
  const [statistic, setStatistic] = React.useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [range, setRange] = React.useState('1');
  const [selectedAppID, setSelectedAppID] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [summary, setSummary] = React.useState('');

  const handleSelectRange = (event) => {
    setRange(event.target.value);
  };

  // function timeout(delay) {
  //   return new Promise(res => setTimeout(res, delay));
  // }

  const columns = [
    { id: 'appIcon', label: '', minWidth: 50 },
    { id: 'appName', label: 'appName', minWidth: 100 },
    { id: 'appID', label: 'appID', minWidth: 100 },
    {
      id: 'purchase',
      label: 'purchase',
      minWidth: 100,
      align: 'left',
      format: (value) => value.toLocaleString('en-US'),
    },
    { id: 'countryOrRegion', label: 'countryOrRegion', minWidth: 100, align: 'center' },
    {
      id: 'createdAt',
      label: 'time',
      minWidth: 100,
      align: 'center',
      format: (value) => value.toLocaleString('en-US'),
    },
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  React.useEffect(() => {
    setLoading(true);
    axios.get(`${window.domain}/api/logs?range=${range}&appID=${selectedAppID}`).then(logData => {
      setRows(logData.data.data);
      setStatistic(logData.data.statistic);
      setSummary(logData.data.summary);
      setLoading(false);
    });
  }, [range, selectedAppID]);

  return (
    <ThemeProvider theme={mdTheme}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Grid container spacing={3}>
          {/* Tracking table */}
          <Grid item xs={4}>
            <Typography variant='caption' color='#6200EE' sx={{ m: 1 }}>STATISTICS</Typography>
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
              <FormControl sx={{ m: 1, width: '95%' }} size="small">
                <InputLabel id="demo-select-small">Range</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={range}
                  label="Range"
                  onChange={handleSelectRange}
                >
                  <MenuItem value={1}>Yesterday</MenuItem>
                  <MenuItem value={3}>Last 3 days</MenuItem>
                  <MenuItem value={6}>This week</MenuItem>
                  <MenuItem value={7}>Last 7 days</MenuItem>
                  <MenuItem value={30}>Last 30 days</MenuItem>
                  <MenuItem value={29}>Current month</MenuItem>
                  <MenuItem value={31}>Last month</MenuItem>
                </Select>
              </FormControl>
              <TableContainer sx={{ maxHeight: '800' }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        key='app_icon'
                        align='left'
                      >
                      </TableCell>
                      <TableCell
                        key='app_name'
                        align='left'
                      >
                        appName
                      </TableCell>
                      <TableCell
                        key='count'
                        align='left'
                      >
                        count
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {statistic.map(row => (
                      <TableRow hover sx={{ background: selectedAppID === row.appID ? '#e0e0e0' : '#ffffff' }} role="checkbox" tabIndex={-1} key={'statistic' + row.appID}>
                        <TableCell key='app_icon' align='left' onClick={() => setSelectedAppID(row.appID)}>
                          <Avatar alt="appIcon" src={row.appIcon !== '' ? row.appIcon : 'https://redbarnstudios206461841.files.wordpress.com/2021/07/a.jpg'} variant="rounded" />
                        </TableCell>
                        <TableCell key='app_icon' align='left' onClick={() => setSelectedAppID(row.appID)}>{row.appName}</TableCell>
                        <TableCell key='app_icon' align='left' onClick={() => setSelectedAppID(row.appID)}>{row.count}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
          <Grid item xs={8}>
            <Paper sx={{ width: '100%', overflow: 'hidden', padding: 1 }}>
              <Typography variant='caption' color='#000'>Country summary</Typography>
              <Typography variant='h6' color='#000'>{summary}</Typography>
            </Paper>
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
              <TableContainer sx={{ maxHeight: 800 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row) => {
                        return (
                          <TableRow hover role="checkbox" tabIndex={-1} key={row._id}>
                            {columns.map((column) => {
                              const value = row[column.id];
                              var cell;
                              if (column.id === 'appIcon') cell = (<TableCell>
                                <Avatar alt="appIcon" src={value} variant="rounded" />
                              </TableCell>)
                              else cell = (
                                <TableCell key={column.id} align={column.align}>
                                  {column.format && typeof value === 'number'
                                    ? column.format(value)
                                    : value}
                                </TableCell>
                              )
                              return cell;
                            })}
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </ThemeProvider >
  );
}

export default OtherAds;